import '../style.css';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import * as dat from 'dat.gui';
import { LightData, CamData } from '../data/default';
import * as PrufObjects from './objects'
import { BandCampIframes } from '../data/bandcampIframes';
import { CSS3DRenderer } from "three/examples/jsm/renderers/CSS3DRenderer";

// Debug
const gui = new dat.GUI();

// Canvas
// const canvas = document.querySelector('canvas.webgl'); // TODO: Remove old canvas
const container = document.getElementById('container');

// Scene
const scene = new THREE.Scene();

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
};

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(CamData.fov, sizes.width / sizes.height, CamData.near, CamData.far);
camera.position.x = 50;
camera.position.y = 350;
camera.position.z = 750;
scene.add(camera);

/**
 * Renderer
 */

/* TODO: Remove old renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
});
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
*/

const renderer = new CSS3DRenderer();
renderer.setSize( sizes.width, sizes.height );
container.appendChild( renderer.domElement );

// Controls
// const controls = new OrbitControls(camera, canvas); // TODO: Remove old controls
const controls = new OrbitControls(camera, renderer.domElement);
controls.enableDamping = true

// Objects
const torusGeo = new THREE.TorusGeometry( .7, .2, 16, 100 );

const boxData = {
    width: 1,
    height: 1,
    depth: 1,
};
const boxGeo = new THREE.BoxGeometry(boxData.width, boxData.height, boxData.depth);

// Materials
const torusMaterial = new THREE.MeshPhongMaterial();
torusMaterial.color = new THREE.Color(0xff0000);

const boxMaterial = new THREE.MeshPhongMaterial();
boxMaterial.color = new THREE.Color(0x00ff00);

// Mesh
const torus = new THREE.Mesh(torusGeo,torusMaterial);
scene.add(torus);
const box = new THREE.Mesh(boxGeo, boxMaterial);
scene.add(box);

const group = new THREE.Group();
for (let i = 0; i < BandCampIframes.length; i++) {
    const iframeData = BandCampIframes[i];
    group.add(
      new PrufObjects.Iframe({
        iframeData,
        x: i * 10,
        y: i * 10,
        z: i * 1000,
        ry: Math.PI / 2,
      })
    );
}
scene.add( group );

const size = 10;
const divisions = 10;

const gridHelper = new THREE.GridHelper( size, divisions );
scene.add( gridHelper );

// Lights
const ambientLight = new THREE.AmbientLight(LightData.color, LightData.intensity - 0.6);
scene.add(ambientLight);
const pointLight = new THREE.DirectionalLight(LightData.color, LightData.intensity);
pointLight.position.x = -1;
pointLight.position.y = 2;
pointLight.position.z = 4;
scene.add(pointLight);

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    // renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
});

// Block iframe events when dragging camera
const blocker = document.getElementById( 'blocker' );
blocker.style.display = 'none';

controls.addEventListener( 'start', function () {
    blocker.style.display = '';
});
controls.addEventListener( 'end', function () {
    blocker.style.display = 'none';
});

/**
 * Animate
 */

const clock = new THREE.Clock();

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime();

    // Update objects
    torus.rotation.y = .5 * elapsedTime;
    box.rotation.x = -0.5 * elapsedTime;
    box.rotation.z = -1 * elapsedTime;

    // Update Orbital Controls
    controls.update()

    // Render
    renderer.render(scene, camera);

    // Call tick again on the next frame
    window.requestAnimationFrame(tick);
}

tick();
